import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Body, CloseButton, Container, Content, Header, Overlay } from './styles';

interface IMyModalProps {
  title?: string;
  hasCloseButton?: boolean;
  isOpen: boolean;
  onClose: () => void;
  isCentered?: boolean;
  maxWidth?: number;
  children: React.ReactNode;
}

const CustomModal: React.FC<IMyModalProps> = ({
  title,
  isOpen,
  onClose,
  hasCloseButton = true,
  isCentered,
  maxWidth = 34,
  children,
}) => {
  const animationVariations = {
    visible: {
      visible: { opacity: 1 },
      hidden: { opacity: 0 },
      zIndex: 100,
      transition: { duration: 0.2, easings: 'easeInOut' },
    },
  };

  if (!isOpen) return <></>;

  return (
    <Container initial="visible" animate={isOpen ? 'visible' : ''} variants={animationVariations}>
      <Overlay isCentered={isCentered} role="button" onClick={onClose} />
      <Body maxWidth={maxWidth}>
        <Header>
          <p>{title || ''}</p>
          {hasCloseButton && (
            <CloseButton type="button" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          )}
        </Header>
        <Content>{children}</Content>
      </Body>
    </Container>
  );
};
export default CustomModal;
